import axios from '@/utils/axios'
const rootUrl = 'jurisdiction/website/common/'
const api = {
  Navigation: rootUrl + 'navigation',
  RegionList: rootUrl + 'regionList',
  Auth: rootUrl + 'auth',
  getAllDepartmentId: '/jurisdiction/website/department/getAllDepartmentId'
}

/**
 * 导航列表
 * quarter_id
 */
export function getNavigationt (parameter) {
  return axios.formRequest.post(api.Navigation, parameter)
}

/**
 * 获取省（负责市所在的省）
 */
export function regionListForFleeing (parent_id = '0', level = 1, is_all = '0') {
  return axios.formRequest.post(
    'jurisdiction/website/common/regionListForFleeing',
    { parent_id, level, is_all }
  )
}

/**
 * 获取省市区
 */
export function regionList (parent_id = '0', level = 1, is_all = '0') {
  return axios.formRequest.post(api.RegionList, { parent_id, level, is_all })
}
/**
 * 快捷填报列表
 */
export function getPureSaleTotalList () {
  return axios.formRequest.post('crm/website/data_report/getPureSaleTotalList')
}
/**
 * 快捷填报列表提示语
 */
export function getSaleReportDateTips () {
  return axios.formRequest.post('crm/website/data_report/getSaleReportDate')
}

/**
 * 获取省市区（分级）
 */
export function regionListByLevel (parent_id = '', level = 1, search_text = '') {
  return axios.formRequest.post(
    'jurisdiction/website/common/regionListByLevel',
    { parent_id, level, search_text }
  )
}

/**
 * 获取终端
 */
export function getAuthClientList (
  cls_array = [1, 2, 3, 4, 5, 6],
  is_ciidee = 0
) {
  return axios.formRequest.post(api.Auth, { cls_array, is_ciidee })
}

/**
 * 获取所有部门id
 */
export function getAllDepartmentId () {
  return axios.formRequest.post(api.getAllDepartmentId)
}

/**
 * 动态获取档案类型
 */
export function getClientActiveCls () {
  return axios.formRequest.post('masterdata/website/client/activeCls', {})
}

/**
 * 新系统动态获取档案类型
 */
export function activeCls (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/activeCls',
    parameter
  )
}

/**
 *保存配置
 */
export function saveSetting (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/globalSave',
    parameter
  )
}

/**
 * 新系统动态获取档案类型
 */
export function getAllCls (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getAllCls',
    parameter
  )
}

/**
 * 部门岗位列表
 */
export function getDepartmentScreen (
  target_department_id,
  search_text,
  is_name = ''
) {
  return axios.formRequest.post(
    'jurisdiction/website/common/departmentScreen',
    {
      target_department_id,
      search_text,
      is_name
    }
  )
}

/**
 * 获取全局配置
 */
export function getGlobalSetting (type) {
  return axios.formRequest.post('masterdata/website/Setting/globalSetting', {
    type
  })
}

/**
 * 版本
 */
export function getDefaultValue (value) {
  return axios.formRequest.post('crm/wap/notice/getWapDefaultValue', {
    value
  })
}

/**
 * 获取设置过共岗功能的档案类型
 */
export function getSettingDetail (parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/share_quarter/getSettingDetail',
    parameter
  )
}

/**
 * pc端连锁总部查询接口
 */
export function brandChainList (parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/brandChainList',
    parameter
  )
}


/**
 * 获取需要提示到期通知的职位
 */
export function getNoticeJob (parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/getNoticeJob',
    parameter
  )
}


/**
 * 获取分类列表
 */
export function categoryList (parent_id = '0', level = 1, is_all = '0') {
  return axios.formRequest.post("masterdata/website/goods/getCategoriesList", { parent_id, level, is_all })
}
